import React, { Fragment } from "react";

import { TableTabs } from "../../../shared/components";
import { DiscoveredDevicesInfo } from "../discoveredDeviceInfo";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../components/table/components";
import { Mobile } from "../../../../../../hocs/Responsive";

export const DiscoveredDeviceTableHeader = () => {
  return (
    <Fragment>
      <TableTabs />
      <DiscoveredDevicesInfo />
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>
    </Fragment>
  );
};
